
import React from "react";
import { Button, Table } from "react-bootstrap";
import { IGetTemplateMailsResponse } from "../../../interfaces/api/ITemplateMails";
import { NavLink } from "react-router-dom";
import Moment from "react-moment";

export default function TableTemplates({ data, handleShowPreview }: { data: IGetTemplateMailsResponse, handleShowPreview: (name: string, uuid: string) => void }) {
    return (
        <div className="table-container">
            <Table className="table list templates">
                <thead>
                    <tr>
                        <th className="name key">Nom</th>
                        <th className="description">Description</th>
                        <th className="type">Type</th>
                        <th className="clientType">Client(s) cible</th>
                        <th className="date">Date Création/Maj</th>
                        <th className="period">Période d'exploitation</th>
                        <th className="status">Statut</th>
                        <th className="actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <TableRow data={data} handleShowPreview={handleShowPreview} />
                </tbody>
            </Table>
        </div>
    );
}

function TableRow({ data, handleShowPreview }: { data: IGetTemplateMailsResponse, handleShowPreview: (name: string, uuid: string) => void }) {
    const rows = data.templates.map((template) => {

        const status = template.status === 'active' ? 'actif' : 'inactif';

        const handlePreview = () => {
            handleShowPreview(template.name, template.uuid);
        };
        return (
            <tr data-status={template.status} key={template.uuid}>
                <td className="name key">
                    <NavLink to={`/templates/${template.uuid}`}>{template.name}</NavLink>
                </td>
                <td className="description">{template.subject}</td>
                <td className="type">{template.type}</td>
                <td className="clientTypes">
                    {template.client_types.map(clientType => clientType.name).join(", ")}
                </td>
                <td className="date">
                    <Moment format="DD/MM/YYYY HH:mm:ss">
                        {template.updated_at}
                    </Moment>
                </td>
                <td className="period">
                    <Moment format="DD/MM/YYYY HH:mm:ss">
                        {template.date_validity_start}
                    </Moment> -  <br />
                    {template.date_validity_end !== null && template.date_validity_end !== '' ? (
                        <Moment format="DD/MM/YYYY HH:mm:ss">
                            {template.date_validity_end}
                        </Moment>
                    ) : 'Sans fin'}
                </td>
                <td className="status"><span className="icon"></span><span className="text">{status}</span></td>
                <td className="actions">
                    <div className="btns-wrapper">
                        <NavLink to={`/templates/${template.uuid}`} className="btn btn-sm btn-edit" title="Modifier">
                            <span className="icon"></span>
                            <span className="text">Modifier</span>
                        </NavLink>
                        <Button variant="none" size="sm" className="btn-email-preview" data-bs-toggle="modal" data-bs-target="#templatePreviewModal" title="Prévisualiser le Template email" onClick={handlePreview}>
                            <span className="icon"></span>
                            <span className="text">Prévisualiser</span>
                        </Button>
                    </div>
                </td>
            </tr>
        );
    });

    return (
        <>
            {rows}
        </>
    );
}